import { combineReducers } from 'redux';
import { APIReducer } from 'store/apiReducer';
import { CONTEXT_CARTE_COLLECTIONNEUR } from '../../constants/apiUrls.constants';

const carteCollectionneur = combineReducers({
    recuperer: APIReducer.bind(null, CONTEXT_CARTE_COLLECTIONNEUR),
});

export default carteCollectionneur;
